import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'en_CY',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '128fda3b-d139-4114-a7b5-63654e85701d',
  ''
);
